export default "<p>merchant-detail-table works!</p>\n"